// extracted by mini-css-extract-plugin
export var boxWrapper = "TitleBox-module--boxWrapper--1bf68";
export var textIcon = "TitleBox-module--textIcon--e7bda";